module.exports = __webpack_public_path__ + "img/background-todos-mobile.0b45f3ce.jpg";